import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

export interface ProductDetailsViewStyles {
    [x: string]: any;
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnInnerContainer?: GridContainerProps;
    topGridItem?: GridItemProps;
    middleGridItem?: GridItemProps;
    middleGridItemHidden?: HiddenProps;
    bottomGridItem?: GridItemProps;
    middleColumnGridItem?: GridItemProps;
    middleColumnContentGridItem?: GridItemProps;
    middleColumnGridItemHidden?: HiddenProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnGridItemHidden?: HiddenProps;
}

export const viewStyles: ProductDetailsViewStyles = {
    leftColumnGridItem: {
        width: [12, 12, 4, 4, 4],
        css: css`
            overflow: hidden;
            direction: ltr;
        `,
    },
    topGridItem: { width: 12 },
    middleGridItem: { width: [12, 12, 8, 8, 8] },
    middleGridItemHidden: {
        below: undefined,
        above: "sm",
        css: css`
            width: 100%;
            direction: ltr;
        `,
    },
    bottomGridItem: { width: 12 },
    middleColumnContentGridItem: {
        width: 12,
        css: css`
            background: #f3f1f1;
            height: fit-content;
        `,
    },
    middleColumnGridItem: { width: [12, 12, 8, 4, 4] },

    middleColumnGridItemHidden: {
        below: "xs",
        css: css`
            width: 100%;
            direction: ltr;
        `,
    },
    rightColumnGridItem: { width: [12, 12, 12, 4, 4] },
    container: {
        css: css`
            direction: ltr;
        `,
        offsetCss: css`
            margin: 0;
            width: 100% !important;
        `,
    },
};

const styles = viewStyles;

const ProductDetailsView: React.FC<WidgetProps> = props => {
    const [rightColumnTopMargin, setRightColumnTopMargin] = React.useState(0);
    React.useEffect(() => {
        const titleHeight = document.querySelector(".titleHeight")?.clientHeight;
        setRightColumnTopMargin(titleHeight ? titleHeight - 76 : 0);
    });
    return (
        <GridContainer {...styles.container} data-test-selector="productDetailsGridContainer" isFullWidth={true}>
            <GridItem {...styles.leftColumnGridItem} data-test-selector="productDetails_leftColumn">
                <GridContainer {...styles.leftColumnInnerContainer}>
                    <GridItem {...styles.topGridItem}>
                        <Zone contentId={props.id} zoneName="ContentBrandImage" />
                    </GridItem>
                    <GridItem {...styles.topGridItem}>
                        <Zone contentId={props.id} zoneName="Content0" />
                    </GridItem>
                    <GridItem {...styles.middleGridItem}>
                        <Hidden {...styles.middleGridItemHidden}>
                            <Zone contentId={props.id} zoneName="Content1" />
                        </Hidden>
                    </GridItem>
                    <GridItem {...styles.bottomGridItem}>
                        <Zone contentId={props.id} zoneName="Content2" />
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem {...styles.middleColumnGridItem} data-test-selector="productDetails_middleColumn">
                <GridContainer>
                    <GridItem {...styles.topGridItem} className="titleHeight">
                        <Zone contentId={props.id} zoneName="ContentBrandTitle" />
                    </GridItem>
                    <GridItem {...styles.middleColumnContentGridItem} className="contentHeight">
                        <Hidden {...styles.middleColumnGridItemHidden}>
                            <Zone contentId={props.id} zoneName="Content3" />
                        </Hidden>
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem
                {...styles.rightColumnGridItem}
                data-test-selector="productDetails_rightColumn"
                style={{ marginTop: rightColumnTopMargin }}
            >
                <Zone contentId={props.id} zoneName="Content4" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect()(ProductDetailsView),
    definition: {
        displayName: "View",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
